<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="grid-column ai-c jc-s gap-10">
        <button
          class="ac-close-button"
          @click="toggleActionModal(false)"
        >
          <img
            src="@shared/assets/img/general/x-black.png"
            alt="x"
            class="ac-close"
          >
        </button>
        <div v-if="showMemberInfo" class="ac-header">
          New Service
        </div>
        <div v-else class="ac-header">
          Schedule
        </div>
      </div>
    </div>
    <div class="ac-body-container">
      <div
        v-if="showMemberInfo"
        class="ac-input-container"
      >
        <div
          class="sac__font-18 med margin-bottom-4"
        >
          Member:
        </div>
        <SACAutoComplete
          :value="serviceJob.customerName"
          placeholder="Search Member"
          label="firstName"
          optionalLabel="lastName"
          extraLabel="fullAddress"
          :searchMethod="getCustomerList"
          :select="(item) => selectResult(item)"
        />
        <div
          v-if="errorObj.memberErr"
          class="sac__font-14 med tomato"
        >
          {{ errorObj.memberErr }}
        </div>
      </div>
      <div class="grid-column even gap-20">
        <div class="ac-input-container">
          <div class="sac__font-18 med margin-bottom-4">
            Schedule Date:
          </div>
          <DatePicker
            class="match-background"
            :value="serviceJob.scheduleDate"
            :minDate="today"
            @input="changeCurrentSR('scheduleDate', $event)"
          />
          <div
            v-if="errorObj.scheduleDateErr"
            class="sac__font-14 med tomato"
          >
            {{ errorObj.scheduleDateErr }}
          </div>
        </div>
        <div class="ac-input-container">
          <div class="sac__font-18 med margin-bottom-4">
            Schedule Time:
          </div>
          <SACDropdown
            :options="confirmedTimeOp"
            :value="serviceJob.scheduleTime"
            placeholder="Select Time"
            field="scheduleTime"
            :change="changeCurrentSR"
            :error="errorObj.scheduleTimeErr"
          />
        </div>
      </div>
      <div class="ac-input-container margin-top-16">
        <div class="sac__font-18 med margin-bottom-4">
          Service Category:
        </div>
        <div
          v-if="loadingServiceCategory"
        >
          <img src="@shared/assets/img/general/loading.svg">
        </div>
        <SACDropdown
          v-else
          :options="serviceCategoryList"
          :value="serviceJob.serviceCategory"
          placeholder="Select Service Category"
          field="serviceCategory"
          optionLabel="category"
          optionValue="category"
          :change="changeCurrentSR"
          :error="errorObj.categoryErr"
        />
      </div>
      <div
        v-if="serviceJob.serviceCategory"
        class="ac-input-container margin-top-24"
      >
        <div class="sac__font-18 med margin-bottom-4">
          Visit Type:
        </div>
        <div
          v-if="loadingVisitType"
        >
          <img src="@shared/assets/img/general/loading.svg">
        </div>
        <SACDropdown
          v-else
          :options="visitTypeList"
          :value="serviceJob.serviceType"
          placeholder="Select Service Type"
          field="serviceType"
          optionLabel="title"
          optionValue="visitType"
          :change="changeCurrentSR"
          :error="errorObj.serviceTypeErr"
        />
      </div>
      <div v-if="serviceJob.serviceType" class="margin-top-24">
        <div class="sac__font-18 med">
          Issues reported:
        </div>
        <div
          v-if="loadingCondition"
        >
          <img src="@shared/assets/img/general/loading.svg">
        </div>
        <div
          v-else-if="issueList.length"
          class="grid-column even"
        >
          <div
            v-for="(item, idx) in issueList"
            :key="idx"
            class="margin-top-4 sac__font-14"
          >
            <SACCheckbox
              :label="item.condition"
              :change="() => updateServiceIssue(item.condition, reportedIssueList.includes(item.condition))"
              :checked="reportedIssueList.includes(item.condition)"
            />
          </div>
        </div>
        <div v-else-if="!loadingCondition && !issueList.length">
          --
        </div>
      </div>
      <div class="ac-input-container margin-top-24">
        <div class="grid-column ai-c jc-b">
          <div class="sac__font-18 med margin-bottom-4">
            Technician
            <span class="sac__font-12">(Optional):</span>
          </div>
          <!--          <button-->
          <!--            v-if="adminRole === 'admin'"-->
          <!--            class="sac__font-14 semi-bold f-primary"-->
          <!--            @click="addTechnician"-->
          <!--          >-->
          <!--            + Add technician-->
          <!--          </button>-->
        </div>
        <SACDropdown
          placeholder="Select Tech"
          searchParameter="label"
          field="assignedTechId"
          :options="getTechOptions(serviceJob.corpId)"
          :value="serviceJob.assignedTechId"
          :change="changeCurrentSR"
        />
      </div>
      <div class="ac-input-container margin-top-24">
        <div class="sac__font-18 med margin-bottom-4">
          Job Value
          <span class="sac__font-12">(Optional):</span>
        </div>
        <SACInput
          field="serviceCost"
          type="number"
          placeholder="Enter $ estimate here.."
          :value="serviceJob.serviceCost"
          :change="changeCurrentSR"
        />
      </div>
      <div class="ac-input-container margin-top-24">
        <div class="sac__font-18 med margin-bottom-4">
          Notes
          <span class="sac__font-12">(Optional):</span>
        </div>
        <textarea
          placeholder="Leave a note here..."
          :value="serviceJob.actionNote"
          @change="changeCurrentSR('actionNote', $event.target.value)"
        />
        <div class="sac__font-14">
          500 character max
        </div>
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        class="sac__button bg-transparent"
        @click="toggleActionModal(false)"
      >
        Cancel
      </button>
      <button
        class="sac__button bg-primary margin-left-16"
        @click="submitSA"
      >
        Submit
      </button>
    </div>
    <ProcessOverlay
      :show="creatingJob"
      text="Creating Job"
      overlayClass="ac-overlay"
    />
  </div>
</template>

<script>
import moment from 'moment';
import SACInput from '@shared/components/sac/SACInput.vue';
import SACDropdown from '@shared/components/sac/SACDropdown.vue';
import DatePicker from '@shared/components/DatePicker.vue';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';
import SACCheckbox from '@shared/components/sac/SACCheckbox.vue';
import serviceMixin from '@shared/mixins/serviceMixin';
import SACAutoComplete from '@shared/components/sac/SACAutoComplete.vue';
import adminMixin from '@shared/mixins/adminMixin';

export default {
  name: 'NewServiceRequest',
  components: {
    SACAutoComplete,
    SACCheckbox,
    SACInput,
    SACDropdown,
    DatePicker,
    ProcessOverlay,
  },
  mixins: [serviceMixin, adminMixin],
  data() {
    return {
      serviceJob: {},
      reportedIssueList: [],
      show: false,
      creatingJob: false,
      loadingServiceCategory: false,
      loadingVisitType: false,
      loadingCondition: false,
      today: new Date(moment().add(1, 'days').format('YYYY-MM-DD')),
      errorObj: {},
    };
  },
  computed: {
    showMemberInfo() {
      return !this.actionRequest.alertNoticeId;
    },
  },
  watch: {
    serviceJob: {
      handler(newVal, oldVal) {
        if (newVal.serviceCategory !== oldVal.serviceCategory) {
          this.getVisitTypeList(newVal.serviceCategory);
        }
        if (newVal.serviceType !== oldVal.serviceType) {
          this.getConditionList(newVal.serviceCategory, newVal.serviceType);
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.serviceJob = { ...this.actionRequest };
    this.getServiceCategoryList();
    this.getTechList();
  },
  methods: {
    async getCustomerList(query) {
      if (this.selectedCorpId < 0) {
        return this.$store.dispatch('searchCustomerList', {
          parentCorpId: this.selectedCorpId * -1,
          customerName: query,
        });
      }
      return this.$store.dispatch('searchCustomerList', {
        corpId: this.selectedCorpId,
        customerName: query,
      });
    },
    async selectResult(item) {
      this.changeCurrentSR('customerId', item.customerId);
      this.changeCurrentSR('serviceAddressId', item.serviceAddressId);
      this.changeCurrentSR('customerName', `${item.firstName} ${item.lastName}`);
      this.changeCurrentSR('corpId', item.corpId);
    },
    updateServiceIssue(issue, checked) {
      if (checked) {
        this.reportedIssueList = this.reportedIssueList.filter((i) => i !== issue);
      } else {
        this.reportedIssueList = [...this.reportedIssueList, issue];
      }

      if (this.reportedIssueList.length) {
        this.changeCurrentSR('serviceIssues', this.reportedIssueList.join(','));
      }
    },
    changeCurrentSR(field, value) {
      this.serviceJob = { ...this.serviceJob, [field]: value };
    },
    async submitSA() {
      const {
        alertNoticeId,
        customerId,
        scheduleDate,
        scheduleTime,
        serviceCategory,
        serviceType,
      } = this.serviceJob;
      const errorObj = {};
      if (!customerId) {
        errorObj.memberErr = 'Select member';
      }
      if (!scheduleDate) {
        errorObj.scheduleDateErr = 'Select schedule date';
      }
      if (!scheduleTime) {
        errorObj.scheduleTimeErr = 'Select schedule time';
      }
      if (!serviceCategory) {
        errorObj.categoryErr = 'Select service category';
      }
      if (!serviceType) {
        errorObj.serviceTypeErr = 'Select service type';
      }
      this.errorObj = errorObj;
      if (Object.keys(errorObj).length === 0) {
        this.creatingJob = true;
        if (alertNoticeId) {
          await this.$store.dispatch('updateAlertNoticeAction', this.serviceJob);
        } else {
          await this.$store.dispatch('createServiceJob', this.serviceJob);
        }
        this.creatingJob = false;
        this.toggleActionModal(false);
      }
    },
  },
};
</script>
